<!-- New generic custom table as per new PCS portal redesign -->

<div class="container-fluid table-container">
  <!-- customise table columns -->
  <app-customize-table-columns
    [columns]="columns"
    [disabled]="loading"
    *ngIf="showColumnSelectAccordion && (columns?.length ?? 0) > 0"
    (changeEvent)="handleColumnSelection($event)"
    [downloadSelected]="selectableRows"
    (downloadEvent)="download($event)"
    [disableDownload]="showFilterAccordion || disableDownload || rows?.length === 0"
    [isDynamic]="dynamicPagination"
  ></app-customize-table-columns>

  <!-- table filter -->
  <app-table-search
    [isDynamic]="dynamicPagination"
    [lowerCaseInput]="lowerCaseInput"
    [disabled]="loading"
    [columns]="columns"
    *ngIf="showFilterAccordion && (columns?.length ?? 0) > 0"
    [filterItems]="inputFilters"
    [tableName]="tableName"
    [downloadSelected]="selectableRows"
    [disableDownload]="disableDownload || rows.length === 0"
    (changeEvent)="handleFiltersChange($event)"
    (downloadEvent)="download($event)"
    [enableExactMatch]="true"
  ></app-table-search>

  <!-- common table data -->
  <div *ngIf="!loading" class="table-responsive card-style mb-3">
    <table class="table m-0 box-shadow">
      <thead>
        <tr>
          <ng-container *ngFor="let column of columns; let colIdx = index; trackBy: trackByColumn">
            <th *ngIf="column.selected" class="resizable" [class.checkbox]="!column.title">
              <div [class]="!!column.title && column.searchable ? ['justify-content-between'] : column?.class">
                <p class="d-block" [class.checkbox]="!column.title">
                  <ng-container *ngIf="column.title">
                    {{ column.title === "selector" ? "" : column.label || column.title }}
                    <app-vficon
                      *ngIf="column.tooltip && column.title !== 'selector'"
                      (click)="column.tooltip ? handleColumnTooltipClick(column.tooltip) : null"
                      class="ml-1 icon-wrapper clickable"
                      [class.clickable]="!!extractUrl(column.tooltip || '')"
                      [tooltip]="column?.tooltip"
                      container="body"
                      placement="left"
                      iconPack="source-system-icons"
                      iconName="info-circle"
                      size="16px"
                      style="margin-top: 16px"
                    ></app-vficon>
                    <span
                      (click)="sortDataByColumn(column, colIdx)"
                      tooltip="Sort data"
                      placement="right"
                      class="clickable px-2 sorting-icon"
                      *ngIf="
                        !!column.title &&
                        (column.sortable ?? column.searchable) &&
                        (currentPage?.length ?? 0) > 1 &&
                        column.title !== 'selector'
                      "
                      [ngSwitch]="sortOrders[column.title]"
                    >
                      <app-vficon
                        *ngSwitchCase="undefined"
                        iconPack="source-system-icons"
                        iconName="chevron-up"
                      ></app-vficon>
                      <app-vficon
                        *ngSwitchCase="'ASC'"
                        iconPack="source-system-icons"
                        iconName="chevron-up"
                      ></app-vficon>
                      <app-vficon
                        *ngSwitchCase="'DESC'"
                        iconPack="source-system-icons"
                        iconName="chevron-down"
                      ></app-vficon>
                    </span>
                  </ng-container>
                  <input
                    class="align-top select-all-cb"
                    #selectAllCb
                    *ngIf="showSelectAllCheckbox && column.title === 'selector'"
                    type="checkbox"
                    (change)="selectAllRows($event, tableRows)"
                    [checked]="areAllRowsSelected"
                  />
                </p>
              </div>
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of currentPage; let rowIndex = index"
          [ngStyle]="{
            background: row[0]?.rowWarning
              ? backgroundColors?.warning
              : row[0]?.rowSuccess
                ? backgroundColors?.success
                : row[0]?.rowDanger
                  ? backgroundColors.danger
                  : row[0]?.rowWhite
                    ? backgroundColors.white
                    : backgroundColors.default,
          }"
        >
          <ng-container *ngFor="let column of columns; index as idx; trackBy: trackByColumn">
            <td
              *ngIf="column.selected"
              [class.warning]="row[idx]?.cellWarning"
              [class.success]="row[idx]?.cellSuccess"
              [class.danger]="row[idx]?.cellDanger"
            >
              @if (isRowInEditMode(rowIndex) && row[idx]?.type === undefined) {
                <!-- Editable input field -->

                <div class="d-flex align-items-center editable-cell h-100 p-2">
                  @if (row[idx]?.inputType === "text") {
                    <input
                      type="text"
                      class="form-control form-control-sm item-name-field"
                      [class]="row[idx]?.classes"
                      [(ngModel)]="row[idx].value"
                      [ngModelOptions]="{ standalone: true }"
                      [placeholder]="row[idx]?.placeholder || ''"
                      [disabled]="row[idx]?.disabled"
                      (change)="notifyCellChange($event, row[idx]?.data, column.title, row)"
                    />
                  }
                  @if (row[idx]?.inputType === "multiSelect") {
                    <app-custom-dropdown
                      class="w-100"
                      [label]="''"
                      [placeholder]="row[idx].selected?.length > 0 ? '' : row[idx]?.placeholder || 'Select items'"
                      [tooltip]="row[idx]?.tooltip || ''"
                      [control]="row[idx].control"
                      [searchControl]="row[idx].searchControl"
                      [data]="row[idx].list"
                      [multiple]="true"
                      [searchable]="true"
                      [isInvalid]="false"
                      [errorMessage]="''"
                      [valueProperty]="'display_name'"
                      [displayProperty]="'display_name'"
                      (valueChange)="notifyCellChange($event, row[idx]?.data, column.title, row)"
                    />
                  }
                </div>
              }
              <ng-container
                *ngIf="
                  !isRowInEditMode(rowIndex) ||
                  (row[idx]?.inputType !== 'text' && row[idx]?.inputType !== 'multiSelect') ||
                  row[idx]?.type !== undefined
                "
              >
                <ng-container *ngIf="row[idx] === undefined || row[idx]?.type === undefined; else elseBock">
                  <p
                    *ngIf="row[idx]?.innerHTML"
                    style="min-width: max-content"
                    [tooltip]="row[idx]?.tooltip"
                    placement="right"
                    [class]="row[idx]?.classes"
                    [ngStyle]="row[idx]?.styles"
                    [innerHTML]="row[idx]?.innerHTML"
                  ></p>
                  <p
                    *ngIf="!row[idx]?.innerHTML"
                    style="min-width: max-content"
                    class="flex-column"
                    [tooltip]="isArray(row[idx]?.value) ? '' : row[idx]?.tooltip"
                    placement="right"
                    [class]="row[idx]?.classes"
                    [ngStyle]="row[idx]?.styles"
                    [class.align-items-start]="isArray(row[idx]?.value)"
                  >
                    <ng-container [ngSwitch]="isArray(row[idx]?.value)">
                      <ng-container *ngSwitchCase="true">
                        <span style="max-width: 41.65rem; word-wrap: break-word">
                          {{ row[idx]?.value.join(",") || "--" }}
                        </span>
                        <app-vficon
                          *ngIf="row[idx]?.icons"
                          [iconName]="row[idx]?.icons"
                          iconPack="source-system-icons"
                        ></app-vficon>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <span style="max-width: 27rem; word-wrap: break-word; width: 100%">
                          <span
                            class="truncate d-inline-block"
                            [title]="(row[idx]?.value || '').length > 10 ? row[idx]?.value : ''"
                            [tooltip]="row[idx]?.value || ''"
                            >{{ row[idx]?.value || "--" }}</span
                          >
                          <app-vficon
                            class="clickable position-relative"
                            style="bottom: 10px; left: 4px"
                            tooltip="Click to copy"
                            size="14px"
                            (click)="copyValue(row[idx]?.rawValue ?? row[idx]?.value)"
                            *ngIf="
                              !row[idx]?.icons &&
                              (row[idx]?.value || 0).substring &&
                              !emptyValues.includes((row[idx]?.value || '--').trim())
                            "
                            iconName="copy"
                            iconPack="source-system-icons"
                          ></app-vficon>
                        </span>
                        <app-vficon
                          *ngIf="row[idx]?.icons"
                          [iconName]="row[idx]?.icons"
                          iconPack="source-system-icons"
                        ></app-vficon>
                      </ng-container>
                    </ng-container>
                  </p>
                </ng-container>
              </ng-container>
              <ng-template #elseBock>
                <p
                  class="non-editable"
                  [ngSwitch]="row[idx]?.type"
                  [class]="row[idx]?.classes"
                  [ngStyle]="row[idx]?.styles"
                  [class.checkbox]="row[idx]?.type === 'checkbox'"
                >
                  <input
                    *ngSwitchCase="'checkbox'"
                    type="checkbox"
                    [class]="row[idx]?.childClasses"
                    [ngStyle]="row[idx]?.childStyles"
                    [(ngModel)]="row[idx].data['$Selected']"
                    [tooltip]="row[idx]?.tooltip"
                    placement="left"
                    container="body"
                    [disabled]="row[idx]?.disabled"
                    (change)="notifyCellChange($event, row[idx]?.data, column.title, row)"
                  />
                  <textarea
                    *ngSwitchCase="'textarea'"
                    type="text"
                    [class]="row[idx]?.childClasses"
                    [ngStyle]="row[idx]?.childStyles"
                    [tooltip]="row[idx]?.tooltip"
                    [cols]="row[idx]?.columns || 40"
                    [rows]="row[idx]?.rows || 2"
                    placement="right"
                    [disabled]="row[idx]?.disabled"
                    [pattern]="row[idx]?.pattern"
                    [(ngModel)]="row[idx].value"
                    [placeholder]="row[idx].placeholder || ''"
                    (keyup)="notifyCellChange($event, row[idx]?.data, column.title, row)"
                  ></textarea>
                  <input
                    *ngSwitchCase="'text'"
                    type="text"
                    [class]="row[idx]?.childClasses"
                    [ngStyle]="row[idx]?.childStyles"
                    [tooltip]="row[idx]?.tooltip"
                    placement="right"
                    [disabled]="row[idx]?.disabled"
                    [pattern]="row[idx]?.pattern"
                    [(ngModel)]="row[idx].value"
                    [placeholder]="row[idx].placeholder || ''"
                    (keyup)="notifyCellChange($event, row[idx]?.data, column.title, row)"
                  />
                  <select
                    *ngSwitchCase="'select'"
                    [name]="column.title"
                    class="table-cell-select"
                    [(ngModel)]="row[idx].selected"
                    [style.background-color]="
                      (row[idx]?.value || []).includes(row[idx]?.selected) ? null : backgroundColors.danger
                    "
                    [class]="row[idx]?.childClasses"
                    [ngStyle]="row[idx]?.childStyles"
                    [tooltip]="row[idx]?.tooltip"
                    placement="right"
                    [disabled]="row[idx]?.disabled"
                    (change)="notifyCellChange($event, row[idx]?.data, column.title, row)"
                  >
                    <option [value]="row[idx].selected" *ngIf="!(row[idx]?.value || []).includes(row[idx].selected)">
                      {{ row[idx].selected }}
                    </option>
                    <option *ngFor="let value of row[idx]?.value" [value]="value">
                      {{ value }}
                    </option>
                  </select>

                  <ng-container *ngSwitchCase="'a'">
                    @if (row[idx]?.href) {
                      <ng-container [ngSwitch]="isArray(row[idx]?.value)">
                        <ng-container *ngSwitchCase="true">
                          <a
                            *ngFor="let value of row[idx]?.value; index as i"
                            [tooltip]="row[idx]?.tooltip?.[i]"
                            [href]="row[idx]?.href?.[i]"
                            [class]="row[idx]?.childClasses"
                            [ngStyle]="row[idx]?.childStyles"
                            target="_blank"
                          >
                            {{ value || "--" }}

                            <app-vficon
                              *ngIf="row[idx]?.icons?.[i]"
                              [iconName]="row[idx]?.icons?.[i]"
                              iconPack="source-system-icons"
                            ></app-vficon>
                          </a>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          <a
                            [tooltip]="row[idx]?.tooltip"
                            placement="right"
                            [href]="row[idx]?.href"
                            [class]="row[idx]?.childClasses"
                            [ngStyle]="row[idx]?.childStyles"
                            target="_blank"
                          >
                            {{ row[idx]?.value || "--" }}

                            <app-vficon
                              *ngIf="row[idx]?.icons"
                              [iconName]="row[idx]?.icons"
                              iconPack="source-system-icons"
                            ></app-vficon>
                          </a>

                          <app-vficon
                            class="clickable position-relative ml-2"
                            style="bottom: 2px"
                            tooltip="Click to copy"
                            size="14px"
                            (click)="copyValue(row[idx]?.href ?? row[idx]?.rawValue ?? row[idx]?.value)"
                            [title]="(row[idx]?.value || '').length > 10 ? row[idx]?.value : ''"
                            *ngIf="!row[idx]?.icons && !emptyValues.includes((row[idx]?.value || '--').trim())"
                            iconName="copy"
                            iconPack="source-system-icons"
                          ></app-vficon>
                        </ng-container>
                      </ng-container>
                    } @else {
                      <ng-container [ngSwitch]="isArray(row[idx]?.value)">
                        <ng-container *ngSwitchCase="true">
                          <a
                            *ngFor="let value of row[idx]?.value; index as i"
                            [tooltip]="row[idx]?.tooltip?.[i]"
                            [routerLink]="row[idx]?.routerLink?.[i]"
                            [queryParams]="row[idx]?.queryParams?.[i]"
                            [class]="row[idx]?.childClasses"
                            [ngStyle]="row[idx]?.childStyles"
                            target="_blank"
                          >
                            {{ value || "--" }}
                            <app-vficon
                              *ngIf="row[idx]?.icons?.[i]"
                              [iconName]="row[idx]?.icons?.[i]"
                              iconPack="source-system-icons"
                            ></app-vficon>
                          </a>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          <a
                            [tooltip]="row[idx]?.tooltip"
                            placement="right"
                            [routerLink]="row[idx]?.routerLink"
                            [queryParams]="row[idx]?.queryParams"
                            [class]="row[idx]?.childClasses"
                            [ngStyle]="row[idx]?.childStyles"
                            target="_blank"
                          >
                            {{ row[idx]?.value || "--" }}
                            <app-vficon
                              *ngIf="row[idx]?.icons"
                              [iconName]="row[idx]?.icons"
                              iconPack="source-system-icons"
                            ></app-vficon>
                          </a>
                          <app-vficon
                            class="clickable position-relative ml-2"
                            style="bottom: 2px"
                            tooltip="Click to copy"
                            size="14px"
                            (click)="copyValue(row[idx]?.rawValue ?? row[idx]?.value)"
                            *ngIf="!row[idx]?.icons && !emptyValues.includes((row[idx]?.value || '--').trim())"
                            iconName="copy"
                            iconPack="source-system-icons"
                          ></app-vficon>
                        </ng-container>
                      </ng-container>
                    }
                  </ng-container>
                  <button
                    *ngSwitchCase="'button'"
                    [type]="row[idx]?.type"
                    [class]="row[idx]?.childClasses"
                    [ngStyle]="row[idx]?.childStyles"
                    [tooltip]="row[idx]?.tooltip"
                    placement="right"
                    [disabled]="row[idx]?.disabled"
                    [routerLink]="row[idx]?.routerLink"
                    [queryParams]="row[idx]?.queryParams"
                    (click)="notifyCellChange($event, row[idx]?.data, column.title, row, row[idx]?.label)"
                  >
                    <span>{{ row[idx]?.label }}</span>
                    <app-vficon
                      size="15px"
                      color="white"
                      *ngIf="row[idx]?.icons"
                      [iconName]="row[idx]?.icons"
                      class="float-right ml-2"
                      iconPack="source-system-icons"
                    ></app-vficon>
                  </button>

                  <!-- scheduler -->
                  <span [class]="{ scheduler: true }" class="scheduler align-items-center">
                    <!-- start/stop time -->
                    @switch (row[idx]?.subtype) {
                      @case ("time") {
                        @for (value of row[idx]?.value; track i; let i = $index) {
                          <span class="mb-1 d-flex align-items-center px-2" style="width: max-content">
                            <span>
                              {{ row[idx]?.data[i].action.split("#")[0] === "start" ? "Start Time" : "Stop Time" }}
                            </span>
                            <span class="ml-2">
                              @switch (row[idx]?.data[i].action.split("#")[0]) {
                                @case ("start") {
                                  <fa-icon
                                    class="mr-2 position-relative text-success time-arrow"
                                    [icon]="faArrowUp"
                                  ></fa-icon>
                                }
                                @case ("stop") {
                                  <fa-icon
                                    class="mr-2 position-relative text-primary time-arrow"
                                    [icon]="faArrowDown"
                                  ></fa-icon>
                                }
                              }
                            </span>
                            <mat-form-field class="time-input-field">
                              <input
                                matInput
                                type="text"
                                [ngxMatTimepicker]="picker"
                                [value]="row[idx].value[i]"
                                [disabled]="
                                  row[idx]?.disabled || (!isRowInEditMode(rowIndex) && isGroupSchedulerTable())
                                "
                                id="timepickeinput"
                              />
                              <ngx-mat-timepicker
                                #picker
                                (timeSet)="notifyCellChange($event, row[idx]?.data[i], column.title, row)"
                              ></ngx-mat-timepicker>
                              <span class="time-zone"> UTC{{ row[idx]?.offset }} </span>
                            </mat-form-field>
                          </span>
                        }
                      }

                      <!-- scheduled days -->
                      @case ("checkbox") {
                        @if (isArray(row[idx]?.data)) {
                          @for (d of row[idx]?.data; track $index; let i = $index) {
                            <span>
                              <input
                                type="checkbox"
                                placement="right"
                                [disabled]="row[idx]?.disabled"
                                [(ngModel)]="row[idx].value[i]"
                                (change)="notifyCellChange($event, row[idx]?.data[i], column.title, row)"
                              />
                            </span>
                          }
                        }
                      }
                      <!-- Week days cell -->
                      @case ("weekDays") {
                        @for (d of row[idx]?.data; track j; let j = $index) {
                          <div class="d-flex justify-content-center align-items-center weekDaysContainer px-2">
                            @for (day of weekDays; track i; let i = $index) {
                              <div class="days d-flex flex-column align-items-center">
                                @if (j === 0) {
                                  <span>{{ daysOfWeek[i] }}</span>
                                }
                                <span>
                                  <input
                                    type="checkbox"
                                    placement="right"
                                    [disabled]="
                                      row[idx]?.disabled || (!isRowInEditMode(rowIndex) && isGroupSchedulerTable())
                                    "
                                    [(ngModel)]="row[idx].value[j][i]"
                                    (change)="
                                      notifyCellChange($event, row[idx]?.data[j], column.title, row, { dayIndex: i })
                                    "
                                  />
                                </span>
                              </div>
                            }
                          </div>
                        }
                      }

                      <!-- enable cell -->
                      @case ("toggle") {
                        @for (d of row[idx]?.data; track d.action; let i = $index) {
                          <span class="enable-cell-container">
                            <div class="enable-cell">
                              <label
                                class="switch position-relative d-inline-block mb-0"
                                [tooltip]="
                                  column.title === 'enabled'
                                    ? row[idx]?.permission && d.enabled
                                      ? 'You cannot opt out of scheduler, please reach out to PCS and follow the exemption process'
                                      : 'Click to enable/disable schedule'
                                    : column.title === 'dbs_enabled'
                                      ? row[idx]?.permission && d.dbs_enabled
                                        ? 'You cannot opt out of database scheduling, please reach out to PCS and follow the exemption process'
                                        : 'Click to include/exclude RDS databases from this schedule'
                                      : ''
                                "
                                placement="left"
                                container="body"
                              >
                                <input
                                  hidden="true"
                                  type="checkbox"
                                  [disabled]="
                                    (column.title === 'enabled'
                                      ? row[idx]?.disabled ||
                                        (d.enabled && !row[idx]?.permission && d.action.split('#')[0] === 'stop')
                                      : column.title === 'dbs_enabled'
                                        ? row[idx]?.disabled || !row[idx]?.permission
                                        : row[idx]?.disabled) ||
                                    (!isRowInEditMode(rowIndex) && isGroupSchedulerTable())
                                  "
                                  [(ngModel)]="row[idx].value[i]"
                                  (change)="notifyCellChange($event, row[idx]?.data[i], column.title, row)"
                                />
                                <span class="slider round"></span>
                              </label>
                            </div>
                          </span>
                        }
                      }
                      <!-- state cell -->
                      @case ("state") {
                        <div
                          class="state-cell d-flex justify-content-center align-items-center"
                          [class]="getStateClass(row[idx]?.value)"
                        >
                          <span>{{ row[idx]?.value }}</span>
                        </div>
                      }
                      <!-- action cell -->
                      @case ("action") {
                        <div class="d-flex justify-content-center align-items-center">
                          @if (getButtonConfig(row[idx]?.value); as btnConfig) {
                            <button
                              class="action-btn"
                              [class]="btnConfig.cssClass"
                              [disabled]="btnConfig.disabled"
                              (click)="
                                notifyCellChange($event, row[idx]?.data, column.title, row, null, btnConfig.text)
                              "
                            >
                              <span class="btn-label">{{ btnConfig.text }}</span>
                            </button>
                          }
                        </div>
                      }

                      <!-- Edit cell -->
                      @case ("update") {
                        <div class="d-flex">
                          @if (!isRowInEditMode(rowIndex)) {
                            <button (click)="toggleEditMode(rowIndex)" class="btn btn-action p-1">
                              <app-vficon
                                size="20px"
                                class="position-relative"
                                color="grey"
                                iconPack="source-system-icons"
                                iconName="edit"
                                tooltip="Edit"
                              />
                            </button>
                            <button (click)="deleteRow(row)" class="btn btn-action p-1">
                              <app-vficon
                                size="20px"
                                class="position-relative"
                                color="red"
                                iconPack="source-system-icons"
                                iconName="delete"
                                tooltip="Delete"
                              />
                            </button>
                          } @else {
                            <button (click)="saveRowChanges(row, rowIndex)" class="btn btn-action p-1">
                              <app-vficon
                                size="20px"
                                class="position-relative"
                                color="green"
                                iconPack="source-system-icons"
                                iconName="tick-circle"
                                tooltip="Save changes"
                              />
                            </button>
                            <button (click)="cancelRowEdit(rowIndex)" class="btn btn-action p-1">
                              <app-vficon
                                size="20px"
                                class="position-relative"
                                color="red"
                                iconName="cancel"
                                tooltip="Cancel"
                              />
                            </button>
                          }
                        </div>
                      }
                      <!-- Edit cell -->
                      @case ("button") {
                        <div class="d-flex">
                          <button
                            class="navigate-btn"
                            (click)="notifyCellChange($event, row[idx]?.data, column.title, row, null)"
                          >
                            <span class="btn-label">{{ row[idx]?.value }}</span>
                          </button>
                        </div>
                      }

                      @case ("exclude") {
                        <div class="d-flex justify-content-center flex-column exclusions">
                          @for (exclusionType of exclusionTypes; track exclusionType.title) {
                            <h5 [class]="exclusionType.colorClass">{{ exclusionType.title }}</h5>
                            @for (e of exclusionType.getFn(row[idx]?.data); track eidx; let eidx = $index) {
                              <div class="card exclusion-card">
                                <div
                                  class="card-header"
                                  [class]="exclusionType.type === 'stop' ? 'stop-header' : 'start-header'"
                                >
                                  Exclusion {{ eidx + 1 }} – {{ exclusionType.title.split(" ")[0] }}
                                </div>
                                <div class="card-body">
                                  <div class="d-flex align-items-center">
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      [tooltip]="
                                        row[idx]?.permission
                                          ? 'AWS tags, these are joined by OR'
                                          : 'You cannot opt out of scheduler, please reach out to PCS and follow the exemption process'
                                      "
                                      [disabled]="row[idx]?.disabled || !row[idx]?.permission"
                                      [pattern]="row[idx]?.pattern"
                                      [placeholder]="row[idx]?.placeholder + ' key'"
                                      [(ngModel)]="e.key"
                                      (change)="
                                        notifyCellChange(
                                          $event,
                                          row[idx]?.data[exclusionType.index],
                                          column.title,
                                          row,
                                          { action: 'key', index: eidx }
                                        )
                                      "
                                    />
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      [tooltip]="
                                        row[idx]?.permission
                                          ? 'AWS tags, these are joined by OR'
                                          : 'You cannot opt out of scheduler, please reach out to PCS and follow the exemption process'
                                      "
                                      [disabled]="row[idx]?.disabled || !row[idx]?.permission"
                                      [pattern]="row[idx]?.pattern"
                                      [placeholder]="row[idx]?.placeholder + ' value'"
                                      [(ngModel)]="e.value"
                                      (change)="
                                        notifyCellChange(
                                          $event,
                                          row[idx]?.data[exclusionType.index],
                                          column.title,
                                          row,
                                          { action: 'value', index: eidx }
                                        )
                                      "
                                    />
                                    <button
                                      type="button"
                                      class="btn btn-sm delete-btn"
                                      [tooltip]="
                                        row[idx]?.permission
                                          ? 'Delete'
                                          : 'You cannot opt out of scheduler, please reach out to PCS and follow the exemption process'
                                      "
                                      [disabled]="row[idx]?.disabled || !row[idx]?.permission"
                                      (click)="
                                        notifyCellChange(
                                          $event,
                                          row[idx]?.data[exclusionType.index],
                                          column.title,
                                          row,
                                          { action: 'delete', index: eidx }
                                        )
                                      "
                                    >
                                      X
                                    </button>
                                  </div>
                                </div>
                              </div>
                            }
                            <button
                              type="button"
                              class="btn new-btn"
                              [class]="exclusionType.type === 'stop' ? 'stop-btn' : 'start-btn'"
                              [tooltip]="
                                row[idx]?.permission
                                  ? exclusionType.tooltip
                                  : 'You cannot opt out of scheduler, please reach out to PCS and follow the exemption process'
                              "
                              [disabled]="row[idx]?.disabled || !row[idx]?.permission"
                              (click)="handleExclusionAdd(row[idx]?.data, exclusionType.type)"
                            >
                              {{ exclusionType.buttonText }}
                            </button>
                          }
                        </div>
                      }
                    }
                  </span>
                </p>
              </ng-template>
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="findColumnValueTotal || computeMomTrend" class="grand-total">
          <ng-container *ngFor="let column of columns; index as idx">
            <td *ngIf="columnNotExcluded(column, idx)">
              <p *ngIf="column.sum" class="find-sum">
                {{ idx === 0 ? "Grand Total" : column.sum ? columnTotal(idx) : "--" }}
              </p>

              <p *ngIf="column.computeMomTrend" class="find-sum">
                {{ idx === 0 ? "Grand Total" : column.computeMomTrend ? columnMomTrend(idx) : "--" }}
              </p>
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="customGrandTotal?.length > 0" class="grand-total">
          <ng-container *ngFor="let column of customGrandTotal; index as i">
            <td *ngIf="columnNotExcluded(column, i)">
              <p class="find-sum">
                {{ column?.value }}
              </p>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>

  <img
    id="vf-loader"
    class="d-block mx-auto mt-5"
    *ngIf="loading"
    src="/assets/images/spinner_logo.svg"
    alt="spinner"
  />

  <!-- pagination -->
  <app-pagination
    *ngIf="showPagination"
    [class.invisible]="(tableRows?.length ?? 0) <= pageSize || loading"
    [pageNumber]="pageNumber"
    [disabled]="loading"
    [isDynamic]="dynamicPagination"
    [exactRows]="exactRows"
    [pageSize]="pageSize"
    (pageChanged)="handlePaginationChange($event)"
    [tableRows]="tableRows"
  ></app-pagination>
</div>
